import { IMenuTabConfig } from "../../../ui-partial/menu-bar/menu-bar.component";

export interface IView<T> extends IMenuTabConfig<T> {
  imgUrl: string;
  description: string;
  hasIndicator?: boolean;
}

export enum SchoolClassification { // school_type
  SECTION_23 = 'section_23',
  FIRST_NATIONS = 'first_nations',
  INSPECTED = 'inspected',
  NON_INSPECTED = 'non_inspected'
}

export interface IAgreementConfirmConfig {
  storageKey: string;
  captionSlug?: string;
  captionSlugs?: string[]; // For multi parts agreement
  checkboxSlug: string;
  btnSlug: string;
}

export interface IAgreementConfirmData {
  isConfirmed: boolean;
  dateTime: string;
}

export const PaymentAgreement: IAgreementConfirmConfig = {
  storageKey: "attest-confirm-private",
  captionSlug: "txt_caption_private_payment_agreement_v2",
  checkboxSlug: "txt_checkbox_private_payment_agreement",
  btnSlug: "btn_accept_attestation"
};

export const AttestAgreementPrivate: IAgreementConfirmConfig = {
  storageKey: "attest-confirm-private",
  captionSlug: "sa_txt_attestation_private_v2",
  checkboxSlug: "txt_checkbox_private_attestation",
  btnSlug: "lbl_agree"
}

export const FirstNationsAgreement: IAgreementConfirmConfig = {
  storageKey: "attest-confirm-fn",
  captionSlug: "txt_caption_first_nations_agreement",
  checkboxSlug: "txt_checkbox_private_payment_agreement", // Use the same text checkbox text as payment agreement
  btnSlug: "btn_accept_attestation"
};

export const AttestAgreementFirstNations: IAgreementConfirmConfig = {
  storageKey: "attest-confirm-fn",
  captionSlug: "sa_txt_attestation_first_nations",
  checkboxSlug: "txt_checkbox_private_attestation", // Use the same text checkbox text as private agreement
  btnSlug: "lbl_agree"
}

export const ProfResponsibilityAgreement: IAgreementConfirmConfig = {
  storageKey: "profresponsibility-confirm",
  captionSlugs: ["txt_caption_public_prof_agreement", "txt_caption_public_prof_agreement_2"],
  checkboxSlug: "txt_checkbox_prof_resp_v2",
  btnSlug: "btn_accept_attestation"
};

export enum SchoolAdminModal {
  VIEW_PAYMENT_AGREEMENT = "VIEW_PAYMENT_AGREEMENT",
  VIEW_FIRST_NATIONS_AGREEMENT = "VIEW_FIRST_NATIONS_AGREEMENT",
}

export enum agreement_type {
  PRIVATE_PAYMENT = 'private_payment',
  FIRST_NATIONS = 'first_nations'
}

export interface IInputRequiredAgreementConfig {
  agreementConfig: IAgreementConfirmConfig
  attestConfig: IAgreementConfirmConfig
  agreement_type: agreement_type
}

export const agreementTypeConfigs: Record<SchoolAdminModal, IInputRequiredAgreementConfig> = {
  [SchoolAdminModal.VIEW_PAYMENT_AGREEMENT]: {
    agreementConfig: PaymentAgreement,
    attestConfig: AttestAgreementPrivate,
    agreement_type: agreement_type.PRIVATE_PAYMENT
  },
  [SchoolAdminModal.VIEW_FIRST_NATIONS_AGREEMENT]: {
    agreementConfig: FirstNationsAgreement,
    attestConfig: AttestAgreementFirstNations,
    agreement_type: agreement_type.FIRST_NATIONS
  }
}

export interface IAttestConfirmData extends IAgreementConfirmData {}
export interface IProfResponsibiityConfirmData extends IAgreementConfirmData {}
